<!--CC: taken from apply-policy.component.html, simplified for onboarding wizard (single page: admin dropdown + policy grid + apply)-->

<div class="flex-column gap-4 f-1-0">

	<!--CC: section 1 — select source admin (dropdown with search)-->
	<div class="flex-row align-items-center gap-3">
		<span style="white-space: nowrap; width: 150px;">Copy policies from:</span>
		<app-dropdown-c style="width: 350px;"
						[enableSearch]="true"
						[items]="fromAdmins"
						itemDisplayKey="email"
						(onItemClicked)="selectAdmin($event.item)"
						[text]="selectedFromAdmin?.email || 'Select source plan'"></app-dropdown-c>
	</div>

	<!--CC: section 2 — copy mode (taken from apply-policy.component.html -> summary step copy mode)-->
	<div class="flex-column gap-2">
		<div class="flex-row align-items-center gap-3">
			<span style="white-space: nowrap; width: 150px;">Copy mode:</span>
			<label class="radio-container m-0" style="display: inline-block;">
				Append (merge into existing)
				<input type="radio" name="onboardingCopyPolicyMode"
					   [(ngModel)]="appendMode"
					   [value]="true">
				<span class="checkmark"></span>
			</label>
			<label class="radio-container m-0" style="display: inline-block;">
				Replace (override existing)
				<input type="radio" name="onboardingCopyPolicyMode"
					   [(ngModel)]="appendMode"
					   [value]="false">
				<span class="checkmark"></span>
			</label>
		</div>
	</div>

	<!--CC: section 3 — select policies (taken from apply-policy.component.html -> select policies step)-->
	<div class="flex-column gap-2 f-1-0 overflow-auto">
		<div class="flex-row align-items-center justify-content-between">
			<span>Select policy components to copy</span>
			<div class="flex-row gap-3 align-items-center">
				<app-dropdown-c style="width: 220px;"
								*ngIf="planPolicyTemplates?.length"
								[enableSearch]="true"
								[items]="planPolicyTemplates"
								itemDisplayKey="name"
								(onItemClicked)="selectPolicyTemplate($event.item)"
								[text]="selectedPolicyTemplate?.name || 'Select policy template'"></app-dropdown-c>
				<a class="blue-link" style="font-size: 0.85rem;" (click)="selectAllPolicies();">Select all</a>
			</div>
		</div>

		<!--CC: taken from apply-policy.component.html -> policy selection grid-->
		<div class="flex-column f-1-0 overflow-auto copy-policy-options gap-0">

			<!--CC: Outbound Shield-->
			<div class="flex-row align-items-center border">
				<div class="flex-column gap-2 justify-content-center align-items-center" style="min-width: 110px; padding: 1rem;">
					<i class="far fa-shield" style="font-size: 1rem;"></i>
					<span class="fw-bold text-center" style="font-size: 0.85rem;">Outbound<br/>Shield</span>
				</div>
				<div class="flex-row align-items-center gap-3 flex-wrap justify-content-start" style="padding: 1rem; border-left: 1px solid lightgray;">
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.outbound.rules = !policy.outbound.rules"
						 [ngClass]="{'active': policy.outbound.rules}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.outbound.rules" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Outbound Rules</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.outbound.policy = !policy.outbound.policy"
						 [ngClass]="{'active': policy.outbound.policy}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.outbound.policy" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Outbound Policy</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.outbound.enforce_domain = !policy.outbound.enforce_domain"
						 [ngClass]="{'active': policy.outbound.enforce_domain}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.outbound.enforce_domain" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Enforce Shared Plan Domain</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.outbound.welcome_email = !policy.outbound.welcome_email"
						 [ngClass]="{'active': policy.outbound.welcome_email}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.outbound.welcome_email" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Send Welcome Email To New Users</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.outbound.outbound_reviewers_quarantine_notifications = !policy.outbound.outbound_reviewers_quarantine_notifications"
						 [ngClass]="{'active': policy.outbound.outbound_reviewers_quarantine_notifications}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.outbound.outbound_reviewers_quarantine_notifications" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Outbound quarantine notification recipients</span>
					</div>
				</div>
			</div>

			<!--CC: Inbound Shield-->
			<div class="flex-row align-items-center border">
				<div class="flex-column gap-2 justify-content-center align-items-center" style="min-width: 110px; padding: 1rem;">
					<i class="far fa-user-shield" style="font-size: 1rem;"></i>
					<span class="fw-bold text-center" style="font-size: 0.85rem;">Inbound<br/>Shield</span>
				</div>
				<div class="flex-row align-items-center gap-3 flex-wrap justify-content-start" style="padding: 1rem; border-left: 1px solid lightgray;">
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.rules = !policy.inbound.rules"
						 [ngClass]="{'active': policy.inbound.rules}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.rules" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Threat Prevention Rules</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.inbound_email_rules = !policy.inbound.inbound_email_rules"
						 [ngClass]="{'active': policy.inbound.inbound_email_rules}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.inbound_email_rules" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Inbound Email Rules</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.phishing_bypass = !policy.inbound.phishing_bypass"
						 [ngClass]="{'active': policy.inbound.phishing_bypass}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.phishing_bypass" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Phishing Simulation Bypass</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.url_rewrite = !policy.inbound.url_rewrite"
						 [ngClass]="{'active': policy.inbound.url_rewrite}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.url_rewrite" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">On-click Link Scan</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.url_tracking = !policy.inbound.url_tracking"
						 [ngClass]="{'active': policy.inbound.url_tracking}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.url_tracking" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">URL Hunting</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.smart_banner = !policy.inbound.smart_banner"
						 [ngClass]="{'active': policy.inbound.smart_banner}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.smart_banner" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Smart Banner</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.senders_whitelist = !policy.inbound.senders_whitelist"
						 [ngClass]="{'active': policy.inbound.senders_whitelist}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.senders_whitelist" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Sender Allowlist</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.senders_whitelist_advanced = !policy.inbound.senders_whitelist_advanced"
						 [ngClass]="{'active': policy.inbound.senders_whitelist_advanced}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.senders_whitelist_advanced" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Sender Allowlist Advanced Settings</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.personal_list_settings = !policy.inbound.personal_list_settings"
						 [ngClass]="{'active': policy.inbound.personal_list_settings}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.personal_list_settings" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Personal List Settings</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.senders_blacklist = !policy.inbound.senders_blacklist"
						 [ngClass]="{'active': policy.inbound.senders_blacklist}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.senders_blacklist" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Sender Blocklist</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.links_whitelist = !policy.inbound.links_whitelist"
						 [ngClass]="{'active': policy.inbound.links_whitelist}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.links_whitelist" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Links Allowlist</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.links_blacklist = !policy.inbound.links_blacklist"
						 [ngClass]="{'active': policy.inbound.links_blacklist}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.links_blacklist" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Links Blocklist</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.attachments_whitelist = !policy.inbound.attachments_whitelist"
						 [ngClass]="{'active': policy.inbound.attachments_whitelist}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.attachments_whitelist" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Attachments Allowlist</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.attachments_blacklist = !policy.inbound.attachments_blacklist"
						 [ngClass]="{'active': policy.inbound.attachments_blacklist}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.attachments_blacklist" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Attachments Blocklist</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.block_files_types = !policy.inbound.block_files_types"
						 [ngClass]="{'active': policy.inbound.block_files_types}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.block_files_types" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Block File Types</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.inbound.block_files_types_extensions = !policy.inbound.block_files_types_extensions"
						 [ngClass]="{'active': policy.inbound.block_files_types_extensions}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.inbound.block_files_types_extensions" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Uncommon File Extensions</span>
					</div>
				</div>
			</div>

			<!--CC: Domain Protection-->
			<div class="flex-row align-items-center border">
				<div class="flex-column gap-2 justify-content-center align-items-center" style="min-width: 110px; padding: 1rem;">
					<i class="far fa-lock" style="font-size: 1rem;"></i>
					<span class="fw-bold text-center" style="font-size: 0.85rem;">Domain<br/>Protection</span>
				</div>
				<div class="flex-row align-items-center gap-3 flex-wrap justify-content-start" style="padding: 1rem; border-left: 1px solid lightgray;">
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.domainProtection.domain_impersonation_enabled = !policy.domainProtection.domain_impersonation_enabled"
						 [ngClass]="{'active': policy.domainProtection.domain_impersonation_enabled}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.domainProtection.domain_impersonation_enabled" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Domain Impersonation Configuration</span>
					</div>
				</div>
			</div>

			<!--CC: Simulation Training-->
			<div class="flex-row align-items-center border">
				<div class="flex-column gap-2 justify-content-center align-items-center" style="min-width: 110px; padding: 1rem;">
					<div style="margin-top: 6px; flex-shrink: 0; width: 16px; height: 16px; color: white; background: #000; mask-size: auto 16px; -webkit-mask-size: auto 16px; mask-repeat: no-repeat; -webkit-mask-repeat: no-repeat; mask-image: url('images/double-hook.svg');"></div>
					<span class="fw-bold text-center" style="font-size: 0.85rem;">Simulation<br/>Training</span>
				</div>
				<div class="flex-row align-items-center gap-3 flex-wrap justify-content-start" style="padding: 1rem; border-left: 1px solid lightgray;">
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.threatSimulation.templates = !policy.threatSimulation.templates"
						 [ngClass]="{'active': policy.threatSimulation.templates}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.threatSimulation.templates" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Templates</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.threatSimulation.materials = !policy.threatSimulation.materials"
						 [ngClass]="{'active': policy.threatSimulation.materials}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.threatSimulation.materials" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Materials</span>
					</div>
				</div>
			</div>

			<!--CC: Account Takeover-->
			<div class="flex-row align-items-center border">
				<div class="flex-column gap-2 justify-content-center align-items-center" style="min-width: 110px; padding: 1rem;">
					<i class="far fa-user-secret" style="font-size: 1rem;"></i>
					<span class="fw-bold text-center" style="font-size: 0.85rem;">Account<br/>Takeover</span>
				</div>
				<div class="flex-row align-items-center gap-3 flex-wrap justify-content-start" style="padding: 1rem; border-left: 1px solid lightgray;">
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.accountTakeover.incident_types = !policy.accountTakeover.incident_types"
						 [ngClass]="{'active': policy.accountTakeover.incident_types}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.accountTakeover.incident_types" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Configuration</span>
					</div>
					<div class="policy-option gap-2" style="width: 180px; cursor: pointer;"
						 (click)="policy.accountTakeover.rules = !policy.accountTakeover.rules"
						 [ngClass]="{'active': policy.accountTakeover.rules}">
						<div class="cover"></div>
						<input type="checkbox" [(ngModel)]="policy.accountTakeover.rules" style="accent-color: white; width: 15px;" />
						<span style="cursor: pointer;">Rules</span>
					</div>
				</div>
			</div>
		</div>
	</div>

</div>
